import {Component, OnInit, Input, ChangeDetectorRef, HostListener, OnDestroy} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Model_WorkflowComponent } from 'src/app/app.models';
import { InventoryInputModel } from '../inventory-input.model';
import { WorkflowComponentsService } from '../../../workflow-components.service';

@Component({
    selector: 'abw-inventory-input-design',
    templateUrl: './inventory-input-design.component.html',
    styleUrls: ['./inventory-input-design.component.scss']
})
export class InventoryInputDesignComponent implements OnInit, OnDestroy {
    isComponentSelected = false;
	@Input() model: InventoryInputModel;
    @Input() value: any;
    onComplete = new Subject();

    constructor(
        private _workflowComponentsService: WorkflowComponentsService,
        private _cdf: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
        this._workflowComponentsService.workflowDesignerComponentSelected$.pipe(takeUntil(this.onComplete)).subscribe(_selectedComponent => {
            this.isComponentSelected = _selectedComponent != null && _selectedComponent.GUID == this.model.additional.GUID;
            this._cdf.detectChanges();
        });
    }

    @HostListener("click") onClick(){
        const base_component = this.model.additional as Model_WorkflowComponent;
        base_component.PROPERTIES = this.value;
        this._workflowComponentsService.workflowDesignerComponentSelected$.next(base_component);
    }

    ngOnDestroy() {
        this.onComplete.next();
        this.onComplete.complete();
    }
}